import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import { __awaiter, __generator } from "tslib";
import { uniCall, notInApp } from '../../utils';
/**
 * 新开 Web View 窗口，并载入指定页面
 */

export function openWebView(_a) {
  var _b = _a.type,
      type = _b === void 0 ? null : _b,
      _c = _a.title,
      title = _c === void 0 ? null : _c,
      url = _a.url,
      _d = _a.isLandscape,
      isLandscape = _d === void 0 ? false : _d,
      _e = _a.fullscreen,
      fullscreen = _e === void 0 ? false : _e,
      _f = _a.statusBarVisible,
      statusBarVisible = _f === void 0 ? true : _f,
      _g = _a.statusContentColorBlack,
      statusContentColorBlack = _g === void 0 ? true : _g;
  return __awaiter(this, void 0, void 0, function () {
    var params;
    return __generator(this, function (_h) {
      if (typeof url !== 'string' || !url) {
        throw new Error("[openWebView] expected parameter \u201Curl\u201D is non-empty string, got \u201C".concat(url, "\u201D"));
      } // url 可以不指定域名


      if (!/^(?:https?:)?\/\//.test(url)) {
        url = "".concat(location.origin).concat(url);
      }

      params = JSON.stringify({
        type: type,
        url: url,
        title: title,
        isLandscape: isLandscape,
        statusBar: fullscreen ? {
          statusBarVisible: statusBarVisible,
          statusContentColorBlack: statusContentColorBlack
        } : null
      });
      return [2
      /*return*/
      , new Promise(function (resolve) {
        var _a;

        try {
          uniCall({
            api: 'openNativeAction',
            param: params
          });
          resolve();
        } catch (err) {
          if (((_a = err) === null || _a === void 0 ? void 0 : _a.message) === notInApp.ERROR_MESSAGE) {
            location.href = url;
          }
        }
      })];
    });
  });
}
/**
 * 新开 Web View 窗口，并载入指定页面
 * @deprecated Use `openWebView` instead
 */

export var openWebview = openWebView;